function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled, { keyframes, css } from 'styled-components';
import ControlButton from '../ControlButton/ControlButton';
import guid from '../utils/guid';
import TscThemeName from '../constants/TscThemeName';
import ContextMenu from '../ContextMenu';
import { getMenuData, getArrowData } from '../utils/popover-menu-origin-calculator';
import tscStyles from '../constants/TscStyles';
import { getClassName } from '../utils/get-class-name';
import TscButtonType from '../constants/TscButtonType';
import TscPopoverOrigin from '../constants/TscPopoverOrigin';
import TscGlyphPlacement from '../constants/TscButtonGlyphPlacement';
var showMenuAnimation = keyframes(["0%{transform:scale(.25) translateX(inherit) translateY(inherit);opacity:0;}100%{transform:scale(1) translateX(inherit) translateY(inherit);opacity:1;}"]);
var hideMenuAnimation = keyframes(["0%{transform:scale(1) translateX(inherit) translateY(inherit);opacity:1;}100%{transform:scale(.25) translateX(inherit) translateY(inherit);opacity:0;display:none;}"]);
var ArrowBorder = styled.div.withConfig({
  displayName: "PopoverButton__ArrowBorder"
})(["position:absolute;top:", ";bottom:", ";left:", ";right:", ";transform:", ";width:0;height:0px;border-style:solid;border-width:0 10px 12px;border-color:transparent transparent lightgray transparent;"], function (props) {
  return props.data.top || 'auto';
}, function (props) {
  return props.data.bottom || 'auto';
}, function (props) {
  return props.data.left || 'auto';
}, function (props) {
  return props.data.right || 'auto';
}, function (props) {
  return props.data.transform || 'auto';
});
var ArrowFill = styled.div.withConfig({
  displayName: "PopoverButton__ArrowFill"
})(["position:absolute;top:", ";bottom:", ";left:", ";right:", ";transform:", ";width:0;height:0;padding-top:1px;border-style:solid;border-width:0 10px 12px;border-color:transparent transparent ", " transparent;"], function (props) {
  return props.data.top || 'auto';
}, function (props) {
  return props.data.bottom || 'auto';
}, function (props) {
  return props.data.left || 'auto';
}, function (props) {
  return props.data.right || 'auto';
}, function (props) {
  return props.data.transform || 'auto';
}, tscStyles.color.ui.dawn.light);
var MenuContainer = styled.div.withConfig({
  displayName: "PopoverButton__MenuContainer"
})(["position:absolute;text-align:left;height:auto;list-style:none;background:", ";box-shadow:1px 1px 12px ", ";z-index:2;border-radius:4px;display:none;top:", ";bottom:", ";left:", ";right:", ";transform:", ";transform-origin:", ";", ""], tscStyles.color.ui.dawn.light, tscStyles.color.global.boxShadow, function (props) {
  return props.data.top || 'auto';
}, function (props) {
  return props.data.bottom || 'auto';
}, function (props) {
  return props.data.left || 'auto';
}, function (props) {
  return props.data.right || 'auto';
}, function (props) {
  return props.data.transform || 'auto';
}, function (props) {
  return props.data.transformOrigin || 'auto';
}, function (props) {
  return props.visible ? css(["display:block;animation:", " 200ms  ease;"], showMenuAnimation) : css(["animation:", " 200ms  ease;animation-fill-mode:forwards;&:focus{outline:none;}"], hideMenuAnimation);
});
var PopoverMenu = styled.ul.withConfig({
  displayName: "PopoverButton__PopoverMenu"
})(["background:", ";border-radius:", ";padding:0.125rem;margin:0;max-width:", ";max-height:", ";overflow-y:auto;overflow-x:hidden;"], function (props) {
  return props.themeName === TscThemeName.dawn ? tscStyles.color.global.white : tscStyles.color.ui.dusk.medium;
}, tscStyles.border.radius.medium, function (props) {
  return props.maxWidth || 'none';
}, function (props) {
  return props.maxHeight || 'none';
});
var PopoverButtonContainer = styled.div.withConfig({
  displayName: "PopoverButton__PopoverButtonContainer"
})(["position:relative;display:inline-block;width:", ";min-width:0rem;flex:0 1 auto;"], function (props) {
  return props.width;
});
var defaultProps = {
  buttonText: '',
  buttonTitle: '',
  buttonType: TscButtonType.tertiary,
  closeMenuOnClick: false,
  disableEventListeners: false,
  glyphPlacement: TscGlyphPlacement.left,
  mobileContextMenuZindex: 1,
  origin: TscPopoverOrigin.bottom,
  popoverMenuMaxHeight: '15rem',
  popoverMenuMaxWidth: '15rem',
  showArrow: false,
  theme: TscThemeName.dawn,
  useMobileMenu: false,
  width: 'auto'
};

var PopoverButton = function PopoverButton(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      buttonGlyph = _defaultProps$props.buttonGlyph,
      buttonRef = _defaultProps$props.buttonRef,
      buttonText = _defaultProps$props.buttonText,
      buttonTitle = _defaultProps$props.buttonTitle,
      buttonType = _defaultProps$props.buttonType,
      className = _defaultProps$props.className,
      closeMenuOnClick = _defaultProps$props.closeMenuOnClick,
      disabled = _defaultProps$props.disabled,
      disableEventListeners = _defaultProps$props.disableEventListeners,
      glyphPlacement = _defaultProps$props.glyphPlacement,
      menuHideRef = _defaultProps$props.menuHideRef,
      menuShowRef = _defaultProps$props.menuShowRef,
      mobileContextMenuTitle = _defaultProps$props.mobileContextMenuTitle,
      mobileContextMenuZindex = _defaultProps$props.mobileContextMenuZindex,
      origin = _defaultProps$props.origin,
      popoverMenu = _defaultProps$props.popoverMenu,
      popoverMenuMaxHeight = _defaultProps$props.popoverMenuMaxHeight,
      popoverMenuMaxWidth = _defaultProps$props.popoverMenuMaxWidth,
      showArrow = _defaultProps$props.showArrow,
      style = _defaultProps$props.style,
      testId = _defaultProps$props.testId,
      themeName = _defaultProps$props.themeName,
      useMobileMenu = _defaultProps$props.useMobileMenu,
      width = _defaultProps$props.width; // overlay the defaultProps and passed in props in logical order and spread to constant values


  if (!buttonGlyph && !buttonText) {
    throw new Error('The prop `buttonText` is required when the prop `buttonGlyph` is not specified.');
  }

  var popoverId = React.useMemo(function () {
    return "popover-button-".concat(guid.new());
  }, []);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      menuVisible = _React$useState2[0],
      setMenuVisible = _React$useState2[1];

  var clickStartedOutsideOfMenu = React.useRef(false);
  var popover = React.useRef(null); // wrap these 2 in callbacks just so we dont play with the referential callback returns and the handlers
  // themselves unnecessarily on re-render, they shouldn't change really during runtime

  var showMenu = React.useMemo(function () {
    var showMenuInstance = function showMenuInstance() {
      setMenuVisible(true);
    };

    if (menuShowRef) {
      menuShowRef.current = showMenuInstance;
    }

    return showMenuInstance;
  }, [menuShowRef]); // menuShowRef dependency is a stretch because consumer should not modify this ref out from under a running component... but :shrug: in-case

  var hideMenu = React.useMemo(function () {
    var hideMenuInstance = function hideMenuInstance() {
      setMenuVisible(false);
    };

    if (menuHideRef) {
      menuHideRef.current = hideMenuInstance;
    }

    return hideMenuInstance;
  }, [menuHideRef]); // menuHideRef dependency is a stretch because consumer should not modify this ref out from under a running component... but :shrug: in-case

  var toggleShowMenu = function toggleShowMenu() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    menuVisible ? hideMenu() : showMenu();
  }; // will always trigger from window.addEventListener, so native...


  var onFocusOut = React.useCallback(function (e) {
    var _popover$current;

    if (e.relatedTarget && e.relatedTarget !== popover.current && !((_popover$current = popover.current) !== null && _popover$current !== void 0 && _popover$current.contains(e.relatedTarget))) {
      hideMenu();
    }
  }, [hideMenu]);
  var resetClickStartedOutsideOfMenuValue = React.useCallback(function () {
    clickStartedOutsideOfMenu.current = false;
  }, []); // will always trigger from window.addEventListener, so native MouseEvent...

  var onMouseDown = React.useCallback(function (e) {
    var _popover$current2;

    if (popover.current === e.target || (_popover$current2 = popover.current) !== null && _popover$current2 !== void 0 && _popover$current2.contains(e.target)) {
      e.preventDefault();
    } else {
      var _e$target;

      clickStartedOutsideOfMenu.current = true;
      (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.addEventListener('scroll', resetClickStartedOutsideOfMenuValue);
      window.addEventListener('scroll', resetClickStartedOutsideOfMenuValue);
    }
  }, [resetClickStartedOutsideOfMenuValue]); // will always trigger from window.addEventListener, so native MouseEvent...

  var onMouseUp = React.useCallback(function (e) {
    var _e$target2;

    (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.removeEventListener('scroll', resetClickStartedOutsideOfMenuValue);
    window.removeEventListener('scroll', resetClickStartedOutsideOfMenuValue);

    if (clickStartedOutsideOfMenu.current) {
      hideMenu();
    }

    resetClickStartedOutsideOfMenuValue();
  }, [resetClickStartedOutsideOfMenuValue, hideMenu]);
  React.useEffect(function () {
    if (disableEventListeners) {
      return;
    }

    if (menuVisible) {
      window.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mouseup', onMouseUp);
      window.addEventListener('focusout', onFocusOut); // eslint-disable-next-line consistent-return

      return function () {
        window.removeEventListener('mousedown', onMouseDown);
        window.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('focusout', onFocusOut);
        window.removeEventListener('scroll', resetClickStartedOutsideOfMenuValue);
      };
    }

    window.removeEventListener('mousedown', onMouseDown);
    window.removeEventListener('mouseup', onMouseUp);
    window.removeEventListener('focusout', onFocusOut);
    window.removeEventListener('scroll', resetClickStartedOutsideOfMenuValue); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableEventListeners, menuVisible]); // dependencies considered here
  // clean these up when component unmounts just to be safe

  React.useEffect(function () {
    return function () {
      window.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('focusout', onFocusOut);
      window.removeEventListener('scroll', resetClickStartedOutsideOfMenuValue); // eslint-disable-next-line react-hooks/exhaustive-deps
    };
  }, []); // on mount/unmount

  var menuElement;

  if (useMobileMenu) {
    menuElement = _jsx(ContextMenu, {
      className: className,
      onClose: hideMenu,
      useMobileMenu: true,
      origin: origin,
      showMenu: menuVisible,
      showArrow: showArrow,
      maxHeight: popoverMenuMaxHeight,
      maxWidth: popoverMenuMaxWidth,
      mobileZindex: mobileContextMenuZindex,
      themeName: themeName,
      mobileMenuTitle: mobileContextMenuTitle,
      closeMenuOnClick: closeMenuOnClick,
      children: popoverMenu
    });
  } else if (closeMenuOnClick) {
    menuElement = _jsxs(MenuContainer, {
      className: getClassName(className, 'menu-container'),
      visible: menuVisible,
      data: getMenuData(origin, showArrow),
      children: [showArrow && _jsx(ArrowBorder, {
        className: getClassName(className, 'arrow-border'),
        data: getArrowData(origin)
      }), showArrow && _jsx(ArrowFill, {
        className: getClassName(className, 'arrow-fill'),
        data: getArrowData(origin)
      }), _jsx("div", {
        onClick: toggleShowMenu,
        children: popoverMenu
      })]
    });
  } else {
    menuElement = _jsxs(MenuContainer, {
      className: getClassName(className, 'menu-container'),
      visible: menuVisible,
      data: getMenuData(origin, showArrow),
      children: [showArrow && _jsx(ArrowBorder, {
        className: getClassName(className, 'arrow-border'),
        data: getArrowData(origin)
      }), showArrow && _jsx(ArrowFill, {
        className: getClassName(className, 'arrow-fill'),
        data: getArrowData(origin)
      }), popoverMenu]
    });
  }

  return _jsxs(PopoverButtonContainer, {
    className: getClassName(className, null, 'container'),
    ref: popover,
    style: style,
    width: width,
    id: popoverId,
    children: [_jsx(ControlButton, {
      className: className,
      title: buttonTitle,
      label: buttonText,
      glyph: buttonGlyph,
      buttonType: buttonType,
      themeName: themeName,
      onClick: toggleShowMenu,
      isFullWidth: true,
      testId: testId,
      disabled: disabled,
      glyphPlacement: glyphPlacement,
      ariaExpanded: menuVisible,
      ref: buttonRef
    }), menuElement]
  });
};

PopoverButton.defaultProps = defaultProps;
export { PopoverMenu, PopoverButtonContainer, MenuContainer, ArrowBorder, ArrowFill };
export default PopoverButton;